import { css, styled } from 'next-yak';

import { IconArrowDown } from '@xing-com/icons';
import { minA11yTargetSize } from '@xing-com/layout-tokens';
import { spaceS, spaceXS, spaceXXS } from '@xing-com/tokens';

import { Flag } from '..';

type IconTransientProps = {
  $show: boolean;
};

// *** States ***
const stateIconDown = css`
  transform: rotate(0deg);
  transition: transform 0.2s linear;
`;

const stateIconUp = css`
  transform: rotate(-180deg);
  transition: transform 0.2s linear;
`;

// *** Components ***
export const InteractiveFlag = styled(Flag)`
  cursor: pointer;
  padding-left: ${spaceS};
  padding-right: ${spaceXS};
  position: relative;

  &::before {
    content: '';
    inset-block-end: -${spaceXS};
    inset-block-start: -${spaceXS};
    inset-inline-end: -${spaceXXS};
    inset-inline-start: -${spaceXXS};
    min-height: ${minA11yTargetSize};
    position: absolute;
  }
`;

export const Icon = styled(IconArrowDown)<IconTransientProps>`
  margin-left: ${spaceXXS};

  @media (prefers-reduced-motion: no-preference) {
    ${({ $show }) => ($show ? stateIconUp : stateIconDown)}
  }

  @media (prefers-reduced-motion: reduce) {
    transform: rotate(${({ $show }) => ($show ? '-180deg' : '0deg')});
    transition: none;
  }
`;
